var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page-error"},[(_vm.error.statusCode === 404)?_c('Error404'):_c('InfoMessage',{attrs:{"type":"error"}},[_vm._v(_vm._s(_vm.infoMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }